import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress } from '@mui/material';
import { lazy, Suspense } from 'react';
import { AccountSettingsContent } from 'widgets/account.settings/ui';
const LazyProvider = lazy(() => import(
// webpackChunkName: 'account-dialog'
'shared/account.settings/model'));
export function AccountSettingsDialog() {
    return (_jsx(Suspense, { fallback: _jsx(CircularProgress, { size: 50, color: "primary", sx: {
                zIndex: 401,
                position: 'absolute',
                left: 'calc(50% - 25px)',
                top: 'calc(50% - 25px)',
            } }), children: _jsx(LazyProvider, { children: _jsx(AccountSettingsContent, {}) }) }));
}
